import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAppStore } from '../store/useAppStore';

export const FloatingReward: React.FC = () => {
  const { coins, xp } = useAppStore();
  const [rewards, setRewards] = useState<
    { id: number; type: 'coin' | 'xp'; amount: number }[]
  >([]);
  const [prevCoins, setPrevCoins] = useState(coins);
  const [prevXp, setPrevXp] = useState(xp);

  useEffect(() => {
    // Only animate if we already had a value (don't animate on initial load)
    if (prevCoins > 0 && coins > prevCoins) {
      const diff = coins - prevCoins;
      const id = Date.now();
      setRewards((prev) => [...prev, { id, type: 'coin', amount: diff }]);
      setTimeout(() => {
        setRewards((prev) => prev.filter((r) => r.id !== id));
      }, 3000);
    }
    setPrevCoins(coins);
  }, [coins, prevCoins]);

  useEffect(() => {
    // Only animate if we already had a value
    if (prevXp > 0 && xp > prevXp) {
      const diff = xp - prevXp;
      const id = Date.now() + 1;
      setRewards((prev) => [...prev, { id, type: 'xp', amount: diff }]);
      setTimeout(() => {
        setRewards((prev) => prev.filter((r) => r.id !== id));
      }, 3000);
    }
    setPrevXp(xp);
  }, [xp, prevXp]);

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <AnimatePresence>
        {rewards.map((reward) => (
          <motion.div
            key={reward.id}
            initial={{ opacity: 0, y: 50, scale: 0.5, x: '-50%' }}
            animate={{ opacity: 1, y: -100, scale: 1.2, x: '-50%' }}
            exit={{ opacity: 0, y: -150, x: '-50%' }}
            transition={{ duration: 2, ease: 'easeOut' }}
            style={{
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              background: 'rgba(0,0,0,0.6)',
              backdropFilter: 'blur(8px)',
              padding: '12px 24px',
              borderRadius: '30px',
              border: `2px solid ${reward.type === 'coin' ? '#f59e0b' : '#f97316'}`,
              boxShadow: `0 0 20px ${reward.type === 'coin' ? 'rgba(245, 158, 11, 0.4)' : 'rgba(249, 115, 22, 0.4)'}`,
              color: 'white',
              fontWeight: 'bold',
              fontSize: '24px',
              whiteSpace: 'nowrap',
            }}
          >
            <span>+{reward.amount}</span>
            <span>{reward.type === 'coin' ? '🏆' : '🍑'}</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
